import SEOHead from "@/components/layout/SEOHead";
import { PageHero } from "@/pages/About.hero";

export default function Privacy() {
  return (
    <>
      <SEOHead title="Privacy Policy" description="Temple Israel of Brevard privacy policy." path="/privacy" />
      <PageHero eyebrow="Privacy" title="Privacy Policy" subtitle="Effective: February 27, 2026" />
      <section className="bg-[var(--paper)] py-20 lg:py-28">
        <div className="max-w-3xl mx-auto px-5 lg:px-10 prose-tiob">
          <p>
            Temple Israel of Brevard ("TIOB," "we," "us") respects your privacy. This policy
            explains what information we collect through this website and how we use it.
          </p>

          <h2>Information We Collect</h2>
          <ul>
            <li><strong>Information you give us</strong> through our contact form, newsletter signup, donation form, or membership inquiry - such as your name, email address, phone number, and message.</li>
            <li><strong>Payment information</strong> for donations is collected and processed by our PCI-compliant payment processor (Stripe). TIOB does not store full card numbers on our servers.</li>
            <li><strong>Standard log information</strong> such as IP address, browser type, and pages visited, used to operate and improve the site.</li>
          </ul>

          <h2>How We Use Information</h2>
          <ul>
            <li>To respond to your inquiry or request.</li>
            <li>To process donations and provide receipts.</li>
            <li>To send the temple bulletin and event updates (only if you subscribe).</li>
            <li>To operate, maintain, and improve our website.</li>
          </ul>

          <h2>Sharing</h2>
          <p>
            We do not sell or rent your personal information. We may share information with
            trusted service providers (e.g., Stripe for payments, our email platform) strictly
            for the purposes above, and as required by law.
          </p>

          <h2>Your Choices</h2>
          <p>
            You may unsubscribe from emails at any time, or contact us to request access to or
            deletion of your personal information.
          </p>

          <h2>Cookies</h2>
          <p>
            Our site uses minimal cookies to remember your accessibility preferences and to
            measure site usage. You may disable cookies in your browser; the site will still work.
          </p>

          <h2>Children's Privacy</h2>
          <p>
            Our site is not directed to children under 13. If you believe we have inadvertently
            collected information from a child, please contact us so we can promptly delete it.
          </p>

          <h2>Contact</h2>
          <p>
            Questions about this policy? Email{" "}
            <a className="text-[var(--cyan-deep)] underline" href="mailto:tioffice@tiofbrevard.com">tioffice@tiofbrevard.com</a> or call (321) 631-9494.
          </p>
        </div>
      </section>
    </>
  );
}
